import React from "react";
import { CronScheduler as CronSchedulerBase } from "@whatslly/ui-components/CronScheduler";
import LOCALES from "./locale";
import { useTranslation } from "react-i18next";

export const CronScheduler = ({ value, onChange }: { value: string; onChange: (value: string) => void }) => {
  const { i18n } = useTranslation();
  return (
    <CronSchedulerBase
      locale={LOCALES[i18n.language as string]}
      clockFormat={"24-hour-clock"}
      allowedPeriods={["week", "day", "hour"]}
      value={value}
      setValue={(cron: string) => onChange(cron)}
    />
  );
};
